/* eslint-disable no-fallthrough */
import { TVehicle } from "types";
interface IFindSimilarVehicles {
  example: TVehicle;
  vehicles: TVehicle[];
  criteria?: string[];
}

export const findSimilarVehicles = ({
  example,
  vehicles,
  criteria = ["modell", "aufbau", "fzart"],
}: IFindSimilarVehicles): TVehicle[] => {
  if (!(example || vehicles.length)) return [];
  let result = vehicles.filter((v: TVehicle) => example.wgnr !== v.wgnr);

  if (criteria.includes("aufbau"))
    result = result.filter((v: TVehicle) => example.aufbau.id === v.aufbau.id);

  if (criteria.includes("marke"))
    result = result.filter(
      (v: TVehicle) => example.modell.marke.id === v.modell.marke.id
    );
  if (criteria.includes("modell"))
    result = result.filter((v: TVehicle) => example.modell.id === v.modell.id);

  if (criteria.includes("fzart"))
    result = result.filter((v: TVehicle) => example.fzart.id === v.fzart.id);

  if (criteria.includes("kraftstoff"))
    result = result.filter(
      (v: TVehicle) => example.kraftstoff.id === v.kraftstoff.id
    );

  if (criteria.includes("farbe_aussen"))
    result = result.filter(
      (v: TVehicle) => example.farbe_aussen?.id === v.farbe_aussen?.id
    );

  return result;
};
